import * as promise from "bluebird";
import * as _types from "./TypesAndIdentifiers";

// base classes for all content types
import _baseQuestion from "./players/question/BaseQuestion";
import _baseSequence from "./players/sequence/BaseSequence";
import _baseActivity from "./players/activity/BaseActivity";
import _baseItem from "./players/item/BaseItem";

// config classes for all content types
import _questionConfig from "./players/question/QuestionConfig";
import _sequenceConfig from "./players/sequence/SequenceConfig";
import _activityConfig from "./players/activity/ActivityConfig";
import _itemConfig from "./players/item/ItemConfig";
import _contentConfig from "./players/content/ContentConfig";
import _blackboard from "./store/Blackboard";

import _player from "./players";
import _helpers from "./helpers";
import * as _ from "lodash";
import _requestClass from "./Request";
import Remind from "./remind/Remind";

promise.config({
  // Enable cancellation
  cancellation: true
});
export namespace plsjs {
  export const init = async () => {
    const player = new Player();
    await player.load();
  };
  // tslint:disable-next-line:variable-name
  export const Types = _types;

  export class Player extends _player { }
  export const request = new _requestClass();
  export const remind = new Remind();
  export const Helper = _.assign({}, _helpers);
  export const Blackboard = _blackboard;

  // // base classes for all content types
  export abstract class BaseActivity extends _baseActivity { }
  export abstract class BaseItem extends _baseItem { }
  export abstract class BaseQuestion extends _baseQuestion { }
  export abstract class BaseSequence extends _baseSequence { }
  // config classes
  export class QuestionConfig extends _questionConfig { }
  export class SequenceConfig extends _sequenceConfig { }
  export class ActivityConfig extends _activityConfig { }
  export class ItemConfig extends _itemConfig { }
  export class ContentConfig extends _contentConfig { }
}
export default plsjs;
// module.exports = module.exports.default;
